import React, { useState } from "react";

function InputFieldsEmailTextPassword({
  containerClassName,
  label,
  type,
  id,
  name,
  placeholder,
  onChange,
  onKeyPress,
  value,
  maxLength,
  autoFocus,
  error,
  isDisabled,
  isReadOnly,
}) {
  // console.log(error);
  const [inputType, setInputType] = useState(type);
  return (
    <div className={`myrl-input-div ${containerClassName}`}>
      <label htmlFor={id ? id : name}>{label}</label>
      <div className="input-border-div">
        <input
          type={type === "password" ? inputType : type}
          id={id ? id : name}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          maxLength={maxLength}
          autoComplete="off"
          autoFocus={autoFocus}
          disabled={isDisabled}
          onKeyPress={onKeyPress}
          readOnly={isReadOnly}
        />
        {type === "password" && inputType === "text" ? (
          <button onClick={() => setInputType("password")}>
            <i className="fa fa-eye-slash"></i>
          </button>
        ) : (
          type === "password" &&
          inputType === "password" && (
            <button onClick={() => setInputType("text")}>
              <i className="fa fa-eye"></i>
            </button>
          )
        )}
      </div>
      {error ? (
        <p className="error-message">{error}</p>
      ) : (
        <p className="error-message opacity-0">error</p>
      )}
    </div>
  );
}

InputFieldsEmailTextPassword.defaultProps = {
  label: "",
  placeholder: "",
  maxLength: "",
  error: "",
  autoFocus: "",
  onKeyPress: () => {},
};

export default InputFieldsEmailTextPassword;
